<div class="d-flex flex-column h-100" style="min-height: 0;">
  <div class="d-inline-flex mb-2" style="margin-left: 8px; margin-top: 8px">
    <dx-button
        *ngIf="!readOnlyUser('templateUpdate')"
        stylingMode="outlined"
        type="default"
        icon="refresh"
        text="{{ 'Produkte aktualisieren' | translate }}"
        hint="{{ 'Die Vorlagen werden auf alle Produkte im Katalog übertragen' | translate }}"
        (onClick)="applyTemplate()"
    ></dx-button>
  </div>

  <dx-tab-panel class="flex-grow-1 np-inner-tab-panel"
                style="min-height: 0;"
                [dataSource]="pages"
                [selectedIndex]="0"
                [swipeEnabled]="false"
                height="100%">
    <div *dxTemplate="let company of 'featureTemplate'">
      <featuresystems
          *ngIf="model"
          displayMode="edit"
          [featureSystems]="model.featureTemplate"
          [hideDefaultSystems]="true"
          (addEcommerceFeatures)="addEcommerceFeatures()"
          (addClassificationFeatures)="addClassificationFeatures($event)"
          (onValueChanged)="categoryUpdate($event)"/>
    </div>

    <div *dxTemplate="let company of 'mediaTemplate'">
      <mimes
          *ngIf="model"
          [model]="model.mimeTemplate"
          [isTemplate]="true"
          [catalogId]="modelService.catalogService.catalog.id"
          [customerId]="modelService.loginService.currentUser.customerId"
          (reloadNedded)="reload()"
          (onValueChanged)="categoryUpdate($event)"/>
    </div>

    <div *dxTemplate="let company of 'wawiTemplate'">
      <wawi [model]="wawiDummyProduct"
            (onValueChanged)="updateWawi($event)"/>
    </div>
  </dx-tab-panel>
</div>